"use client";

import { useCallback, useState } from "react";

// Drives the cancel step of the confirmation card: one in-flight request, one
// error message, and a boolean answer the card can branch on.
//
// The request goes through our own route rather than straight to Cal so the
// API key stays server-side.
export const useCancelBooking = () => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const cancel = useCallback(async (uid: string, reason: string) => {
    setPending(true);
    setError(null);
    try {
      const res = await fetch("/api/cal-booking/cancel", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          uid,
          reason
        })
      });
      const payload = await res.json().catch(() => null);
      if (!res.ok) {
        setError(payload?.error ?? "We could not cancel it here — use the link in your confirmation email.");
        setPending(false);
        return false;
      }
      setPending(false);
      return true;
    } catch {
      setError("Network trouble — use the link in your confirmation email instead.");
      setPending(false);
      return false;
    }
  }, []);
  return {
    pending,
    error,
    cancel
  };
};